
import { cookieExists, deleteCookie, getCookie, setCookie } from "@ciaopeople/cp-shatsu/Cookie";
import guid from "@ciaopeople/cp-shatsu/Utils";
import { DeviceId, DeviceIdInfo, DeviceIdProvider } from "../DeviceIdProvider.js";
import { PersonalDataStorageInterface } from "../PersonalDataStorageInterface.js";

const WIZARD_COOKIE = "fp_wiz";
const NOTIFICATION_UNSUB_COOKIE = "fp_unsub";
const CTA_LAST_SHOWED = "fp_cta_ls";
const SEX_AND_RANGE = "fp_sar";
const DEFAULT_COOKIE_PATH = "/";

const DEVICE_ID_COOKIE = "devid";

const TRACKING_OPTOUT_COOKIE = "prof_optout";


/**
 * Questa classe è responsabile per la gestione dei
 * dati personali salvati a livello di client piuttosto che a livello
 * di utente. In questa implementazione i dati vengono salvati all'interno di cookie
 * @class PersonalDataHandler
 * @param {String} cookieDomain dominio dei cookie
 * @constructor
 */
export class PersonalDataStorageCookieImpl implements PersonalDataStorageInterface, DeviceIdProvider {
    constructor(
        private domain: string
    ) {

    }
    
    /**
     * Imposta nei dati personali il flag per il completamento del wizard.
     * Naturalmente va invocato quando il wizard viene completato almeno una volta
     * con successo
     * 
     */
    public setWizardCompleted(): void {
        setCookie(
            WIZARD_COOKIE,
            1000,
            "true",
            this.domain,
            DEFAULT_COOKIE_PATH,
            true,
            "None"
        );
    }

    
    
    /**
    * Verifica se il wizard è stato completato almeno una volta.
    */
    public isWizardCompleted(): Promise<boolean> {
        return Promise.resolve(getCookie(WIZARD_COOKIE) === "true");
    }
    
    

    private getDeviceId(): DeviceId {
        return getCookie(DEVICE_ID_COOKIE);
    }

    private setDeviceId(d: DeviceId): void {
        setCookie(
            DEVICE_ID_COOKIE,
            3000,
            d,
            this.domain,
            DEFAULT_COOKIE_PATH,
            true,
            "None"
        );
    }

    public retrieveOrGenerateDeviceId(): Promise<DeviceIdInfo> {
        let currentDevId: DeviceId = this.getDeviceId();
        let generated = false;
        if(!currentDevId || currentDevId == "") {
            currentDevId = guid();
            this.setDeviceId(currentDevId);
            generated = true;
        }

        return Promise.resolve({
            deviceId: currentDevId,
            freshlyGenerated: generated
        });

    }


    /**
     * Imposta nei dati personali il flag per inibire l'auto subscription delle notifiche.
     * Naturalmente va invocato quando l'utente volontariamente disattiva le notifiche
     * con successo
     * @method setNotificationsUnsubscribed
     */
    public setNotificationsUnsubscribed(): void {
        setCookie(
            NOTIFICATION_UNSUB_COOKIE,
            28,
            "true",
            this.domain,
            DEFAULT_COOKIE_PATH,
            true,
            "None"
        );
    }
    
    /**
     * Elimina dai dati personali il flag per inibire l'auto subscription delle notifiche.
     * Naturalmente va invocato quando l'utente volontariamente attiva le notifiche
     * con successo
     * @method unsetNotificationsUnsubscribed
     */
    public unsetNotificationsUnsubscribed() {
        deleteCookie(NOTIFICATION_UNSUB_COOKIE, this.domain, DEFAULT_COOKIE_PATH);
        
    }
    
    /**
     * Verifica se le notifiche sono state disattivate volontariamente dall'utente.
     * @method isNotificationsUnsubscribed
     */
    public isNotificationsUnsubscribed(): Promise<boolean> {
        return Promise.resolve(getCookie(NOTIFICATION_UNSUB_COOKIE) === "true") ;
    }
    
    /**
     * setta il timestamp dell'utlima volta che è stato mostrato
     * un dialog del calltoaction
     * @method setCTALastShowed
     *
     */
    public setCTALastShowed(): void {
        setCookie(
            CTA_LAST_SHOWED,
            365,
            "" + (new Date()).getTime(),
            this.domain,
            DEFAULT_COOKIE_PATH,
            true,
            "None"
        );
    }
 
    public setSexAndRange(sar: string): void {
        console.log("[SAR] Setting SAR remote", sar);

        setCookie(
            SEX_AND_RANGE,
            1200,
            sar,
            this.domain,
            DEFAULT_COOKIE_PATH,
            true,
            "None"
        );
    }
    
    /**
     * Verifica il timestamp dell'ultima volta che stato mostrato
     * un dialog delle call to action.
     */
    public getCTALastShowed(): Promise<number> {
        const ck = getCookie(CTA_LAST_SHOWED);
        const ival = parseInt(ck);
        if ( ck && !isNaN(ival) ) {
            return Promise.resolve(ival);
        }
        else {
            return Promise.resolve(null);
        }
    }

    setTrackingOptOut(v: boolean): Promise<void> {
        if (v) {
            setCookie(
                TRACKING_OPTOUT_COOKIE,
                1000,
                "1",
                this.domain,
                DEFAULT_COOKIE_PATH,
                true,
                "None"
            );
        }
        else {
            deleteCookie(
                TRACKING_OPTOUT_COOKIE,
                this.domain,
                DEFAULT_COOKIE_PATH
            );
        }
        return Promise.resolve();
    }
    getTrackingOptOut(): Promise<boolean> {
        return Promise.resolve(
            cookieExists(TRACKING_OPTOUT_COOKIE) && getCookie(TRACKING_OPTOUT_COOKIE) == "1"
        );
    }
}
